import { Component, OnInit } from '@angular/core';
import { ThemeService } from '../../service/theme.service';
import { IotService } from '../../service/iot.service';
import { FilterService } from '../../service/filter.service';
import { ClientService } from '../../service/client.service';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

interface DevicesLocation {
  thingName: string;
  address: string;
  gps: string;
  clientId: string;
}

@Component({
  selector: 'app-iot-devices-location',
  templateUrl: './iot-devices-location.component.html',
  styleUrls: ['./iot-devices-location.component.css'],
  standalone: false
})
export class IotDevicesLocationComponent implements OnInit {
  selectedClient: string = '';
  filterThingSubGroup: string = '';
  clientSubGroups: any[] = [];
  originalClientSubGroups: any[] = [];
  originalDeviceList: any[] = [];
  deviceList: any[] = [];
  originalDevicesWithGps: DevicesLocation[] = [];
  filteredDevicesWithGps: DevicesLocation[] = [];
  thingClient: any[] = [];
  iscloseClientSelectModalOpen = false;
  selectedClientId: string | null = null;

  constructor(
    public theme: ThemeService,
    public iotService: IotService,
    private filter: FilterService,
    private clientService: ClientService,
    private location: Location,
    private router: Router
  ) {}

  async ngOnInit(): Promise<void> {
    await this.initData();
  }

  async initData() {
    this.iotService.resetDevicesArray();
    await this.clientService.getClientsForSelect();
    await this.getClientSubGroups();
    await this.iotService.adminDeviceArray().then(() => {
      this.originalDeviceList = [...this.iotService.devicesArray];
      this.deviceList = [...this.originalDeviceList];
    });
    this.thingClient = [...this.clientService.clientsArray || []];
    this.originalDevicesWithGps = this.getOriginalDevicesWithGps();
    console.log("original: ", this.originalDevicesWithGps)
    this.filteredDevicesWithGps = [...this.originalDevicesWithGps];
    console.log("filtered: ", this.filteredDevicesWithGps)
  }

  get clientSelectOptions() {
    const allLabel = 'all';
    return [
      { label: allLabel, value: '' },
      ...(this.thingClient || []).map((client: any) => ({
        label: client.client_name || client.legal_name,
        value: client.client_id,
      })),
    ];
  }

  get clientSubGroupOptions() {
    const allLabel = 'all';
    return [
      { label: allLabel, value: '' },
      ...(this.clientSubGroups || []).map((subGroup: any) => ({
        label: subGroup.sub_group_name,
        value: subGroup.sub_groupID,
      })),
    ];
  }

  async sortByClients() {
    if (this.selectedClient === '') {
      this.filteredDevicesWithGps = [...this.originalDevicesWithGps];
      this.originalClientSubGroups = [];
      this.filterThingSubGroup = '';
    } else {
      this.filteredDevicesWithGps = this.originalDevicesWithGps.filter(
        (device: DevicesLocation) => device.clientId === this.selectedClient
      );
    }
    await this.getClientSubGroups();
  }

  async sortByClientSubGroups() {
    if (this.filterThingSubGroup) {
      const sg = this.clientSubGroups.find(
        (sg: any) => sg.sub_groupID === this.filterThingSubGroup
      );

      if (sg) {
        const thingNames = sg.devices.map((d: any) => d.thing_name);

        this.iotService.devicesArray = this.originalDeviceList.filter(
          (device: any) => thingNames.includes(device.thingName)
        );

        this.filteredDevicesWithGps = this.originalDevicesWithGps.filter(
          (device: any) => thingNames.includes(device.thingName)
        );
      } else {
        this.sortByClients();
        this.iotService.devicesArray = this.filter.search(
          this.selectedClient,
          this.deviceList,
          this.originalDeviceList,
          'bin.client_id'
        );
      }
    } else {
      this.iotService.devicesArray = this.filter.search(
        this.selectedClient,
        this.deviceList,
        this.originalDeviceList,
        'bin.client_id'
      );
    }
  }

  async getClientSubGroups() {
    try {
      const response: any = await this.iotService.getClientSubGroups(this.selectedClient);
      console.log(response)
      this.originalClientSubGroups = Array.isArray(response) ? response : [];
      this.clientSubGroups = [...this.originalClientSubGroups];
    } catch (err) {
      console.error('Failed to load subgroups', err);
    }
  }

  private getOriginalDevicesWithGps() {
    const originalDevicesWithGps: DevicesLocation[] = [];
    this.iotService.devicesArray.filter((device: any) => {
      if (device.bin && device.bin.bin_gps) {
        const item: DevicesLocation = {
          thingName: device.thingName || '',
          address: device.bin.bin_address || '',
          gps: device.bin.bin_gps || '',
          clientId: device.bin.client_id || '',
        };
        originalDevicesWithGps.push(item);
      }
    });
    return originalDevicesWithGps;
  }

  devicesLocationClicked() {
    this.location.go('iot/devices-location');
  }

  navigateToSubGroup(clientId: string | null) {
    if (clientId) {
      this.router.navigate(['/device-sub-group/create', clientId]);
    }
  }

  openSubgroupModal(event: Event): void {
    event.stopPropagation();
    this.iscloseClientSelectModalOpen = true;
  }

  closeClientSelectModal(): void {
    this.iscloseClientSelectModalOpen = false;
    this.selectedClientId = null;
  }

  confirmSubgroupClient(): void {
    if (this.selectedClientId) {
      this.iscloseClientSelectModalOpen = false;
      this.router.navigate(['/device-sub-group/create', this.selectedClientId]);
    }
  }
}
